import React from "react";
import styled from "styled-components";
import { theme } from "../../styles/theme";

const SectionContainer = styled.section`
  background-image: url("./assets/images/background_stone.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: ${theme.spacing.xxxl} ${theme.spacing.xl};
  min-height: 70vh;
  display: flex;
  justify-content: center;
  position: relative;

  @media (max-width: ${theme.breakpoints.tablet}) {
    padding: ${theme.spacing.xxl} ${theme.spacing.lg};
  }
`;

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${theme.spacing.xl};
`;

const CharacterImage = styled.img`
  width: 100%;
  max-width: 700px;
  height: auto;
  margin: ${theme.spacing.lg} 0;

  @media (max-width: 1440px) {
    max-width: 600px;
  }

  @media (max-width: ${theme.breakpoints.desktop}) {
    max-width: 550px;
  }

  @media (max-width: ${theme.breakpoints.tablet}) {
    max-width: 404px;
  }

  @media (max-width: ${theme.breakpoints.mobile}) {
    max-width: 280px;
  }
`;

const ButtonsRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${theme.spacing.xxl};
  margin-top: ${theme.spacing.xl};

  @media (max-width: ${theme.breakpoints.tablet}) {
    flex-direction: column;
    gap: ${theme.spacing.xl};
  }
`;

const SocialIconContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: ${theme.spacing.lg};
`;

const SocialIcon = styled.button`
  display: inline-block;
  width: 55px;
  height: 55px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0px;
  transition: transform 0.3s;

  &:hover {
    transform: scale(1.1);
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  @media (max-width: ${theme.breakpoints.tablet}) {
    width: 35px;
    height: 35px;
  }
`;

const FooterContainer = styled.div`
  position: absolute;
  bottom: ${theme.spacing.xl};

  @media (max-width: ${theme.breakpoints.tablet}) {
    position: static;
    bottom: auto;
    right: auto;
    transform: none;
    text-align: center;
  }
`;

const CopyrightLink = styled.a`
  font-size: 0.8rem;
  color: ${theme.colors.text.primary};
  text-decoration: none;
`;

const DownloadSection: React.FC = () => {
  // X(Twitter)への投稿
  const shareToTwitter = () => {
    const text = "#防サギ訓練 で詐欺の手口や対策をクイズゲームで学ぼう！";
    const url = "https://go.trendmicro.com/jp/forHome/mktcp/bosagi/game/";

    const encodedText = encodeURIComponent(text);
    const encodedUrl = encodeURIComponent(url);

    const twitterUrl = `https://x.com/share?text=${encodedText}&url=${encodedUrl}`;
    window.open(twitterUrl, "_blank", "width=600,height=400");
  };

  // Facebookへの投稿
  const shareToFacebook = () => {
    const text = "#防サギ訓練 で詐欺の手口や対策をクイズゲームで学ぼう！";
    const url = "https://go.trendmicro.com/jp/forHome/mktcp/bosagi/game/";
    const encodedUrl = encodeURIComponent(url);
    const encodedText = encodeURIComponent(text);

    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}&quote=${encodedText}`;
    window.open(facebookUrl, "_blank", "width=600,height=400");
  };

  // LINEへの投稿
  const shareToLINE = () => {
    const text = "#防サギ訓練 で詐欺の手口や対策をクイズゲームで学ぼう！";
    const url = "https://go.trendmicro.com/jp/forHome/mktcp/bosagi/game/";
    const encodedText = encodeURIComponent(text);
    const encodedUrl = encodeURIComponent(url);

    const lineUrl = `https://social-plugins.line.me/lineit/share?url=${encodedUrl}&text=${encodedText}`;
    window.open(lineUrl, "_blank", "width=600,height=400");
  };

  return (
    <SectionContainer id="download">
      <Container>
        <CharacterImage
          src="./assets/images/shokai_aset.png"
          alt="キャラクター紹介"
          loading="lazy"
        />

        <ButtonsRow>
          <SocialIconContainer>
            <SocialIcon onClick={shareToFacebook} aria-label="Facebook">
              <img src="./assets/images/facebook.png" alt="Facebook" loading="lazy" />
            </SocialIcon>

            <SocialIcon onClick={shareToLINE} aria-label="Line">
              <img src="./assets/images/line.png" alt="Line" loading="lazy" />
            </SocialIcon>

            <SocialIcon onClick={shareToTwitter} aria-label="X (Twitter)">
              <img src="./assets/images/twitter.png" alt="X" loading="lazy" />
            </SocialIcon>
          </SocialIconContainer>
        </ButtonsRow>
        <FooterContainer>
          <CopyrightLink>
            Copyright © {new Date().getFullYear()} Trend Micro Incorporated. All rights reserved.
          </CopyrightLink>
        </FooterContainer>
      </Container>
    </SectionContainer>
  );
};

export default DownloadSection;